import {until} from 'lit-html/directives/until';
import {
  jobStatusLabels,
  jobTypesLabels,
  jobStagesLabels,
  jobStatusDescriptions,
  inviteResultLabels,
  generalLabels
} from '../i18n-labels';
import {
  jobStatuses,
  jobTypes,
  productLabels,
  rosterJobStages,
} from '../constants-enumerate';
import {UserJobs} from '../user-jobs';
import '../export-search-job';

const failed = (ctx, html) => {
  const isRosterType = [jobTypes.ROSTER_FULL, jobTypes.ROSTER_NEW].indexOf(ctx.job.job_type) !== -1;
  if (isRosterType && ctx.job.params.data_type === 'classlink' && ctx.job.stage === rosterJobStages.ROSTER_VALIDATE_ERRORS) {
    return html`${until(ctx.__('<tt-Q98+636v>', 'Could not connect with your ClassLink roster because it does not follow their proper hierarchy structure. You may correct this in ClassLink and try connecting again, or select a different roster method.'))}`;
  }

  let jobStatusDescription = jobStatusLabels[ctx.job.status];
  if (ctx.job.job_type === jobTypes.LICENSING && ctx.job.status === jobStatuses.FAILED) {
    jobStatusDescription = jobStatusDescriptions[ctx.job.status];
  }

  return html`
  <h5 class="alert-heading">${until(jobTypesLabels[ctx.job.job_type])}</h5>
  <p class="mb-0">${until(jobStagesLabels[ctx.job.job_type][ctx.job.stage])}</p>`;
};
const inProgress = (ctx, html) => html`
  <h5 class="alert-heading text-dark">${until(jobTypesLabels[ctx.job.job_type])} (${ctx.job.percentage}%)</h5>

  <p class="mb-0 text-dark">${until(jobStatusLabels[ctx.job.status])} ${until(jobStagesLabels[ctx.job.job_type][ctx.job.stage])}</p>
`;

const done = (ctx, html) => {
  if ((ctx.job.job_type === jobTypes.TEACHER_INVITES || ctx.job.job_type === jobTypes.INVITES) && ctx.invalid) {
    const total = ctx.job.result.invalid_emails + ctx.job.result.fatal_errors;
    return html`${until(ctx._r(ctx.__('<tt-B8GOPf53>', '%r1% of the email addresses are not valid and invites were not delivered.'), total))}`;
  }

  const isRosterType = [jobTypes.ROSTER_FULL, jobTypes.ROSTER_NEW].indexOf(ctx.job.job_type) !== -1;
  if (isRosterType && ctx.job.params.data_type !== 'aofl' && ctx.job.params.data_type !== 'oneroster') {
    if (ctx.job.params.data_type === 'classlink' && ctx.job.result.skipped_class_count > 0) {
      return html`${until(ctx.__('<tt-xPI7+XJR>', 'Roster imported successfully, however, <strong><u>some classes in your roster do not belong to a school</u></strong>. Those classes were skipped. You can update the roster in ClassLink if needed, and those classes will be imported in the next sync.'))}`;
    }

    return html`${until(ctx.__('<tt-J3WgwsU2>', 'Roster imported successfully. Please remember that you cannot edit data in this system. To make edits, you must make changes in the source system, which will be updated on the next sync.'))}`;
  }

  const extra = [];
  if (
    ctx.job.job_type === jobTypes.EXPORT_SEARCH ||
    ctx.job.job_type === jobTypes.INVITES_PRINT ||
    ctx.job.job_type === jobTypes.ROSTER_EXPORT ||
    ctx.job.job_type === jobTypes.GENERATE_QR ||
    ctx.job.job_type === jobTypes.DASHBOARD_CSV_EXPORT)
  {
    extra.push(html`<export-search-job tabIndex="0" class="btn btn-dark btn-block cursor-pointer w-100" .job="${ctx.job}">${until(generalLabels.download)} <span class="ai ai-download"></span></export-search-job>`);
  }
  if (( ctx.job.job_type === jobTypes.INVITES ||
        ctx.job.job_type === jobTypes.TEACHER_INVITES ||
        ctx.job.job_type === jobTypes.ADMIN_INVITES)
    && Object.keys(ctx.job.result).length > 0
  ) {
    if (Object.keys(ctx.job.result.invites_sent_by_product).length) {
      Object.keys(ctx.job.result.invites_sent_by_product).forEach((product) => {
        extra.push(html`<div>${until(inviteResultLabels.productInvitesSent(productLabels[product]))}: ${ctx.job.result.invites_sent_by_product[product]}</div>`);
      });
    } else {
      extra.push(html`<div>${until(inviteResultLabels.sent)}: ${ctx.job.result.invites_sent}</div>`);
    }

    if (ctx.job.result.users_already_active) {
      extra.push(html`<div>${until(inviteResultLabels.usersAlreadyActive)}: ${ctx.job.result.users_already_active}</div>`);
    }

    if (ctx.job.result.skipped > 0) {
      extra.push(html`<div>${until(inviteResultLabels.skipped)}: ${ctx.job.result.skipped}</div>`);
    }

    if (ctx.job.result.skipped_due_to_test_email > 0) {
      extra.push(html`<div>${until(inviteResultLabels.skipped_due_to_test_email)}: ${ctx.job.result.skipped_due_to_test_email}</div>`);
    }
  }

  return html`
    <h5 class="alert-heading">${until(jobTypesLabels[ctx.job.job_type])} (${ctx.job.percentage}%)</h5>
    <p class="mb-0">${until(jobStatusLabels[ctx.job.status])} ${until(jobStagesLabels[ctx.job.job_type][ctx.job.stage])}</p>

    ${extra}
  `;
};

const canceled = (ctx, html) => html`
  <h5 class="alert-heading">${until(jobTypesLabels[ctx.job.job_type])}</h5>
  <p class="mb-0">${until(jobStatusLabels[ctx.job.status])} ${until(jobStagesLabels[ctx.job.job_type][ctx.job.stage])}</p>
`;


export default (ctx, html) => {
  if (ctx.job === null) return '';

  if (ctx.job.status === jobStatuses.FAILED) {
    return failed(ctx, html);
  } else if (ctx.job.status === jobStatuses.CANCELED) {
    return canceled(ctx, html);
  } else if (UserJobs.isDone(ctx.job)) {
    return done(ctx, html);
  }

  return inProgress(ctx, html);
};
